import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useFormValidationState } from '@react-stately/form';
import { useState } from 'react';
import { useOverlayTriggerState } from 'react-stately';
import { useSelectListState } from './use-select-list-state.esm.js';

/**
 * Provides state management for a select component. Handles building a collection
 * of items from props, handles the open state for the popup menu, and manages
 * multiple selection state.
 */
function useSelectState(props) {
  var triggerState = useOverlayTriggerState(props);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    focusStrategy = _useState2[0],
    setFocusStrategy = _useState2[1];
  var listState = useSelectListState(_objectSpread2(_objectSpread2({}, props), {}, {
    onSelectionChange: function onSelectionChange(key) {
      if (props.onSelectionChange != null) {
        props.onSelectionChange(key);
      }
      if (!props.multiple) {
        triggerState.close();
      }
      validationState.commitValidation();
    }
  }));
  var validationState = useFormValidationState(_objectSpread2(_objectSpread2({}, props), {}, {
    value: listState.selectedKey
  }));
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setFocused = _useState4[1];
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, validationState), listState), triggerState), {}, {
    focusStrategy: focusStrategy,
    open: function open() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Don't open if the collection is empty.
      if (listState.collection.size !== 0) {
        setFocusStrategy(focusStrategy);
        triggerState.open();
      }
    },
    toggle: function toggle() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (listState.collection.size !== 0) {
        setFocusStrategy(focusStrategy);
        triggerState.toggle();
      }
    },
    isFocused: isFocused,
    setFocused: setFocused
  });
}

export { useSelectState };
//# sourceMappingURL=use-select-state.esm.js.map
